module.exports = __webpack_public_path__ + "static/img/clouds.c72cbb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clouds.jpg
// module id = wevW
// module chunks = 0